// extracted by mini-css-extract-plugin
export default {"form":"Checkout-form_form__+rTEH","btn":"Checkout-form_btn__KNa+5"};